import { Notification } from '.';

export const AccessControlUpdated: Notification<boolean> = {
    message: 'AccessControlUpdated'
};
